<div class="container-fluid position-relative">
  <div class="row login-row1">
    <div class="col-xl-6 xol-lg-6 col-md-6 col-sm-6 col-12 login-div-6">
      <div class="left-panel"></div>
    </div>
    <div class="center-panel">
      <div class="div_loading" [hidden]="!loading">
        <div class="my-container">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
      <!-- ******************************************************************************************** -->
      <div style="padding:0 8px 0 11px" [hidden]="validation_cellphone == true">
        <h3 class="title pb-0">
          <img src="../../../../../assets/images/logo_new.svg" style="max-width:22rem;height: 3.5rem;" />

        </h3>
        <hr />
        <form [formGroup]="form1" (ngSubmit)="check_server_login()">
          <label for="title" class='wh-label'>
            <div class="login-label">
              <span>نام کاربری</span>
            </div>
            <input class="wh-input" formControlName="username">
          </label>

          <label for="password" class='wh-label password'>
            <div class="login-label">
              <span> رمز عبور </span>
            </div>
            <input type="password" class="wh-input" formControlName="password">
          </label>

          <div class="row mt-3 mb-1">
            <div class="col-12 col-sm-6" style="text-align: right;">
              <span class="text-muted" style="cursor: pointer;" (click)="forget_pass()">
                بازگردانی رمز عبور
              </span>
            </div>
            <div class="col-12 col-sm-6 text-start" style="text-align: right;">
              <mat-checkbox class="reminder" style="vertical-align:text-top" formControlName="remember">
              </mat-checkbox>
              <span>مرا به خاطر بسپار</span>
            </div>

          </div>

          <div class="login-buttons">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 login-buttons2">
                <a href="https://finty.ir/pricing/">
                  <button type="button" class="login-button">
                    <span>عضو نیستید؟</span>
                  </button>
                </a>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 login-buttons2">
                <button type="submit" class="login-button1" [disabled]="!form1.valid">
                  <div class="spinner-border spinner-border-sm" role="status" *ngIf="entering == true || loading">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <span *ngIf="entering == false && !loading" style="cursor: pointer;">
                    <span>ورود به فینتی</span>
                  </span>
                </button>
              </div>
            </div>
          </div>

        </form>

      </div>

      <!-- ******************************************************************************************** -->
      <div style="padding:4rem 16px 0 22px" [hidden]="validation_cellphone == false">
        <form [formGroup]="form2" (ngSubmit)="login(2)">
          <label for="code" class='wh-label'>
            <div class="login-label" style="padding-bottom: 0.6rem;"> لطفا کد دریافتی را در باکس پایین وارد
              کنید:</div>
            <input class="wh-input code center" formControlName="code" required minlength="5" maxlength="5" length="5"
              (keypress)="serverService.get_number($event)">
          </label>
          <div style="text-align: center " class="login-buttons">
            <button type="submit" class="login-button" [disabled]="!form2.valid">تایید کد و ورود</button>
          </div>
        </form>


      </div>

      <!-- ******************************************************************************************** -->
    </div>

  </div>
</div>